import React from "react";
import Nav from "./Components/Navbar/nav";

export default function App() {
  return (
    <>
      <div>
        <Nav />
      </div>
    </>
  );
}
